import { ICoupon, IProgram, IService } from "@interfaces";
import React, { memo, useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import { Input, Form, Row, Col, FormInstance, AutoComplete } from "antd";
import { useYup } from "@validations";
import { useTranslation } from "react-i18next";

import { FormAction } from "src/Components/FormAction";
import { PATH_COUPON_LIST } from "@configs";
import { useDispatch } from "react-redux";
import { setLoading } from "@redux";
import { couponApi } from "@api";
import { useNotify } from "@utils";
import { useHistory } from "react-router";
interface IProps {
  coupon?: ICoupon;
}

const initValue: Partial<ICoupon> = {
  programName: "",
  serviceName: "",
  noOfCoupons: 0,
  programId: null,
  serviceId: null,
  familyName: "",
};

export const CouponForm = memo(({ coupon }: IProps) => {
  const formRef = React.useRef<FormInstance>(null);
  const { YupCoupon } = useYup();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { success, error } = useNotify();
  const couponSchema = Yup.object().shape(YupCoupon);
  const [couponForm] = Form.useForm();
  const [fetching, setFetching] = useState<boolean>(false);
  const [programs, setPrograms] = useState<IProgram[]>([]);
  const [services, setServices] = useState<IService[]>([]);
  const [porgramId, setProgramId] = useState<string>("");
  const [serviceId, setServiceId] = useState<string>("");

  const onFinish = async (values: ICoupon) => {
    try {
      dispatch(setLoading(true));
      await couponApi.create({ ...values, programId: porgramId, serviceId: serviceId, status: true, noOfCoupons: Number(values.noOfCoupons) });
      success(t("message.create.success"));
      history.push(PATH_COUPON_LIST);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const yupSync = {
    async validator({ field }: any, value: any) {
      await couponSchema.validateSyncAt(field, { [field]: value });
    },
  };

  const programVal: string = Form.useWatch("programName", couponForm);
  const serviceVal: string = Form.useWatch("serviceName", couponForm);

  useEffect(() => {
    searchService();
  }, [serviceVal]);
  useEffect(() => {
    searchProgram();
  }, [programVal]);

  const getServiceValues = (data: IService[]) => {
    return data.reduce<IService[]>((a, c) => {
      a.push({ ...c, value: c?.serviceName || "" });
      return a;
    }, []);
  };
  const getProgramValues = (data: IProgram[]) => {
    return data.reduce<IProgram[]>((a, c) => {
      a.push({ ...c, value: c?.programName || "" });
      console.log(a);
      return a;
    }, []);
  };

  const searchService = useCallback(async () => {
    try {
      setFetching(true);
      const res = await couponApi.searchServiceName(serviceVal);
      setServices(getServiceValues(res.data?.data));
      setFetching(false);
    } catch (err: any) {
      // error(err.message);
      setFetching(false);
    } finally {
      setFetching(false);
    }
  }, [serviceVal]);

  const searchProgram = useCallback(async () => {
    try {
      setFetching(true);
      const res = await couponApi.searchProgram(programVal);
      setPrograms(getProgramValues(res.data?.data));
      setFetching(false);
    } catch (err: any) {
      // error(err.message);
      setFetching(false);
    } finally {
      setFetching(false);
    }
  }, [programVal]);

  const onSelectProgram = (value: string, option: IProgram) => {
    setProgramId(option?._id || "");
  };
  const onSelectService = (value: string, option: IService) => {
    setServiceId(option?._id || "");
  };

  const handleSearchProgram = (value: string) => {
    couponForm.setFieldsValue({ programName: value });
  };
  const handleSearchService = (value: string) => {
    couponForm.setFieldsValue({ serviceName: value });
  };
  return (
    <Form
      form={couponForm}
      name="basic"
      ref={formRef}
      initialValues={initValue}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
    >
      <Row gutter={{ md: 54, lg: 54 }}>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.coupon_family_name")} name="familyName" rules={[yupSync]}>
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.program_name")} name="programName" rules={[yupSync]}>
            <AutoComplete
              options={programs}
              onSelect={onSelectProgram}
              onSearch={handleSearchProgram}
              placeholder="type program name"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ md: 54, lg: 54 }}>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.service_name")} name="serviceName" rules={[yupSync]}>
            <AutoComplete
              options={services}
              onSelect={onSelectService}
              onSearch={handleSearchService}
              placeholder="type service name"
            />
          </Form.Item>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.number_of_coupons")} name="noOfCoupons" rules={[yupSync]}>
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      <FormAction />
    </Form>
  );
});
